export const customerPasswordRegExp = /(?=.*\d)(?=.*[A-Za-z])(?=.*[!#$%&*?@^_-])(?!.*\s).{8,}/;
export const invalidPasswordMsg = 'Password must be 8 characters, including 1 letter, 1 special symbol, and 1 number.';
